module.exports = __webpack_public_path__ + "static/media/payment-stock-icon.4911556a.svg";